import { useContext } from 'react';
import { TranslationContext } from '../providers/TranslationProvider';
export const useTranslation = () => {
    const context = useContext(TranslationContext);
    if (!context) {
        throw new Error('useTranslation must be used within a TranslationProvider');
    }
    const { currentLanguage, setLanguage, t, availableLanguages } = context;
    return {
        t,
        currentLanguage,
        setLanguage,
        availableLanguages,
        isCurrentLanguage: (language) => currentLanguage === language,
        translate: (key, variables) => t(key, variables),
    };
};
